/* Drops With Benefits - afrekenknop, PayPal-linkje en vangnet.
   Instellingen komen uit sections/checkout-guard.liquid via window.DWB_CHECKOUT. */
(function () {
  var C = window.DWB_CHECKOUT || {};
  if (!C.enabled) return;

  var LABEL = C.label;
  var SHOW_LOCK = C.showLock;
  var GUARD = C.guard;
  var STRIP_ONCLICK = C.stripOnclick;
  var SHOW_LINK = C.showLink;
  var LINK_TEXT = C.linkText;
  var WAIT_ONETIME = C.waitOnetime * 1000;
  var WAIT_SUB = C.waitSub * 1000;
  var DEBUG = C.debug;

  var BTN = "button[name='checkout'], .modern-cart-checkout-btn, [data-fh-button-type]";
  var SEPA = '[data-fh-button-type="sepa"]';
  var LOCK = '<svg class="dwb-lock" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
             '<rect x="4" y="10.5" width="16" height="10.5" rx="2.5"></rect>' +
             '<path d="M8 10.5V7a4 4 0 0 1 8 0v3.5"></path></svg>';

  function log() {
    if (DEBUG && window.console) console.log.apply(console, ['[Afrekenen]'].concat([].slice.call(arguments)));
  }

  function zichtbaar(el) {
    if (!el) return false;
    var r;
    try { r = el.getBoundingClientRect(); } catch (e) { return false; }
    return r.width > 0 && r.height > 0;
  }

  /* Zit er een abonnement in de winkelwagen? Firmhouse toont dan zijn eigen
     SEPA-knop. Dat is een synchroon, betrouwbaar signaal: geen fetch nodig. */
  function abonnementInWagen() {
    var alle;
    try { alle = document.querySelectorAll(SEPA); } catch (e) { return false; }
    for (var i = 0; i < alle.length; i++) if (zichtbaar(alle[i])) return true;
    return false;
  }

  /* ---------- Knop gelijktrekken ---------- */

  function relabel(btn) {
    if (!btn) return;

    /* Slotjes van het thema zelf verbergen: er mag er precies een zijn, de onze. */
    var svgs = btn.querySelectorAll('svg');
    for (var m = 0; m < svgs.length; m++) {
      var s = svgs[m];
      if (s.classList && s.classList.contains('dwb-lock')) continue;
      if (s.closest && s.closest('.dwb-lock-wrap')) continue;
      if (s.getAttribute('data-dwb-verborgen') === '1') continue;
      s.setAttribute('data-dwb-verborgen', '1');
      try { s.style.setProperty('display', 'none', 'important'); } catch (e) {}
    }

    var current = (btn.textContent || '').replace(/\s+/g, ' ').trim();
    if (btn.getAttribute('data-dwb-label') === LABEL && current === LABEL) return;

    var set = false;
    var nodes = btn.childNodes;
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (n.nodeType === 3 && n.textContent.trim()) { n.textContent = LABEL; set = true; break; }
    }
    if (!set) {
      var spans = btn.querySelectorAll('span');
      for (var j = 0; j < spans.length; j++) {
        if (spans[j].textContent.trim() && !spans[j].querySelector('img,svg')) {
          spans[j].textContent = LABEL; set = true; break;
        }
      }
    }
    if (!set) btn.appendChild(document.createTextNode(LABEL));

    var sloten = btn.querySelectorAll('.dwb-lock-wrap');
    for (var k = 1; k < sloten.length; k++) sloten[k].parentNode.removeChild(sloten[k]);

    if (SHOW_LOCK && !btn.querySelector('.dwb-lock-wrap')) {
      var holder = document.createElement('span');
      holder.className = 'dwb-lock-wrap';
      holder.innerHTML = LOCK;
      btn.insertBefore(holder, btn.firstChild);
    }

    btn.setAttribute('data-dwb-label', LABEL);
    btn.classList.add('dwb-checkout-btn');
  }

  /* ---------- Harde /checkout-redirect ----------
     Die moet er ALTIJD uit, ook bij een eenmalige aankoop. Hij bakt het doel
     vast op het moment dat de pagina laadt, en dat doel klopt niet meer zodra
     de klant wisselt tussen eenmalig en abonnement. Iemand die net op abonnement
     is overgestapt zou dan alsnog in de gewone checkout belanden - en daar is
     geen iDEAL of Bancontact voor abonnementen.

     Waar de klik heen moet, bepalen we hieronder pas bij de klik zelf, op basis
     van wat er op dat moment echt in de winkelwagen zit. */
  function schakel(btn) {
    if (!STRIP_ONCLICK || !btn) return;
    var oc = btn.getAttribute('onclick');
    if (!oc || oc.indexOf('/checkout') === -1) return;
    btn.setAttribute('data-dwb-was-onclick', oc);
    btn.removeAttribute('onclick');
    try { btn.onclick = null; } catch (e) {}
    log('harde /checkout-redirect verwijderd');
  }

  /* ---------- PayPal-linkje ----------
     Staat onder elke zichtbare afrekenknop, dus de winkelwagen ziet er hetzelfde
     uit of je nu een abonnement of een eenmalige aankoop hebt. Geen eigen
     geheugen: wat niet zichtbaar is, krijgt geen link. */

  function bouwLink() {
    var a = document.createElement('button');
    a.type = 'button';
    a.className = 'dwb-paypal-link';
    a.setAttribute('data-dwb-link', '1');
    a.textContent = LINK_TEXT;
    a.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      log('PayPal-route gekozen');
      window.location.href = '/checkout';
    });
    return a;
  }

  function laatWrappen(par) {
    try {
      var cs = window.getComputedStyle(par);
      if (cs && cs.display.indexOf('flex') > -1 && cs.flexWrap !== 'wrap') {
        par.style.setProperty('flex-wrap', 'wrap', 'important');
      }
    } catch (e) {}
  }

  function syncLink() {
    var actief = [];
    try {
      Array.prototype.forEach.call(document.querySelectorAll(BTN), function (b) {
        if (zichtbaar(b)) actief.push(b);
      });
    } catch (e) { return; }

    if (!SHOW_LINK || !actief.length) {
      Array.prototype.forEach.call(document.querySelectorAll('[data-dwb-link="1"]'), function (el) {
        if (el.parentNode) el.parentNode.removeChild(el);
      });
      return;
    }

    actief.forEach(function (primary) {
      var par = primary.parentNode;
      if (!par) return;

      /* Staat het linkje al direct onder deze knop? Dan is er niets te doen. */
      var next = primary.nextElementSibling;
      if (next && next.matches && next.matches('[data-dwb-link="1"]')) { laatWrappen(par); return; }

      /* Anders: een bestaand linkje verplaatsen, of er een maken. Verplaatsen is
         belangrijk - na een wissel van eenmalig naar abonnement wordt een andere
         knop zichtbaar, en dan moet het linkje mee. */
      var bestaand = null;
      for (var i = 0; i < par.children.length; i++) {
        if (par.children[i].matches && par.children[i].matches('[data-dwb-link="1"]')) { bestaand = par.children[i]; break; }
      }
      par.insertBefore(bestaand || bouwLink(), primary.nextSibling);
      laatWrappen(par);
    });

    /* Opruimen: per ouder een link, en geen linkjes bij verdwenen knoppen. */
    var ouders = [];
    actief.forEach(function (p) { if (p.parentNode && ouders.indexOf(p.parentNode) === -1) ouders.push(p.parentNode); });
    Array.prototype.forEach.call(document.querySelectorAll('[data-dwb-link="1"]'), function (el) {
      if (ouders.indexOf(el.parentNode) === -1 && el.parentNode) el.parentNode.removeChild(el);
    });
    ouders.forEach(function (par) {
      var links = [];
      for (var i = 0; i < par.children.length; i++) {
        if (par.children[i].matches && par.children[i].matches('[data-dwb-link="1"]')) links.push(par.children[i]);
      }
      for (var j = 1; j < links.length; j++) links[j].parentNode.removeChild(links[j]);
    });
  }

  function normalize() {
    var list;
    try { list = document.querySelectorAll(BTN); } catch (e) { return; }
    Array.prototype.forEach.call(list, function (b) { schakel(b); relabel(b); });
    syncLink();
    pakAbonneerKnop();
  }

  /* ---------- "Abonneer & Bespaar" ----------
     Het thema zet met deze knop een oud Loop Subscriptions-plan in de winkelwagen
     (691761021251 / 691761054019). Dat is niet Firmhouse. Gevolg: zo'n bestelling
     komt nooit in Firmhouse terecht - geen levering, geen incasso - en de checkout
     biedt alleen PayPal in plaats van iDEAL en Bancontact.

     We nemen de knop over en zetten het juiste Firmhouse-plan in de wagen: exact
     hetzelfde plan dat je krijgt via "Routine" op de productpagina. De plan-id's
     staan hier niet hardgecodeerd maar worden opgezocht, zodat dit blijft werken
     als de plannen ooit veranderen. */

  /* Firmhouse maakt van elk plan een SEPA-tweeling: dezelfde naam met een
     onzichtbaar teken erachter. Het plan zonder dat teken is het startplan. */
  var ONZICHTBAAR = '\u200C';

  function firmhousePlan(handle, variantId, cb) {
    if (!handle) { cb(null); return; }
    fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var variant = null;
        (p.variants || []).forEach(function (v) { if (v.id === variantId) variant = v; });
        if (!variant) { cb(null); return; }

        var toegestaan = {};
        (variant.selling_plan_allocations || []).forEach(function (a) { toegestaan[a.selling_plan_id] = true; });

        var gekozen = null;
        (p.selling_plan_groups || []).forEach(function (g) {
          var namen = {};
          (g.selling_plans || []).forEach(function (sp) { namen[sp.name] = true; });
          (g.selling_plans || []).forEach(function (sp) {
            if (gekozen) return;
            if (!namen[sp.name + ONZICHTBAAR]) return;   /* geen tweeling = geen Firmhouse */
            if (!toegestaan[sp.id]) return;              /* variant mag dit plan niet */
            gekozen = sp.id;
          });
        });
        cb(gekozen);
      })
      .catch(function () { cb(null); });
  }

  function abonneer() {
    var btn = document.getElementById('subscribeAndSaveBtn');
    if (btn) { btn.disabled = true; btn.textContent = 'Bezig...'; }

    function klaar() {
      if (btn) { btn.disabled = false; btn.textContent = 'Abonneer & Bespaar'; }
      if (typeof window.loadCart === 'function') { try { window.loadCart(); } catch (e) {} }
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      normalize();
    }

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var eenmalig = (cart.items || []).filter(function (i) { return !i.selling_plan_allocation; });
        if (!eenmalig.length) { klaar(); return; }

        var rest = eenmalig.slice();
        (function volgende() {
          if (!rest.length) { klaar(); return; }
          var item = rest.shift();
          var handle = item.handle || (String(item.url || '').split('/products/')[1] || '').split('?')[0];

          firmhousePlan(handle, item.variant_id, function (planId) {
            if (!planId) { log('geen Firmhouse-plan voor', handle); volgende(); return; }
            fetch('/cart/change.js', {
              method: 'POST', headers: { 'Content-Type': 'application/json' },
              credentials: 'same-origin', body: JSON.stringify({ id: item.key, quantity: 0 })
            }).then(function () {
              return fetch('/cart/add.js', {
                method: 'POST', headers: { 'Content-Type': 'application/json' },
                credentials: 'same-origin',
                body: JSON.stringify({ id: item.variant_id, quantity: item.quantity, selling_plan: planId })
              });
            }).then(function () { log('omgezet naar Firmhouse-plan', planId); volgende(); })
              .catch(function (e) { log('omzetten mislukt', e); volgende(); });
          });
        })();
      })
      .catch(function (e) { log('winkelwagen lezen mislukt', e); klaar(); });
  }

  /* De knop van het thema roept convertToSubscription() aan via een inline
     onclick. We vervangen die functie, en blijven controleren of het thema hem
     later niet opnieuw overschrijft. */
  function pakAbonneerKnop() {
    if (window.convertToSubscription !== abonneer) window.convertToSubscription = abonneer;
  }

  /* ---------- Vangnet ---------- */

  var seq = 0;
  document.addEventListener('click', function () { seq++; }, true);

  function cartHasPlan(cb) {
    try {
      fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var items = (c && c.items) || [];
          cb(items.some(function (i) { return !!i.selling_plan_allocation; }));
        })
        .catch(function () { cb(false); });
    } catch (e) { cb(false); }
  }

  if (GUARD) {
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('[data-dwb-link="1"]')) return;
      var btn;
      try { btn = t.closest(BTN); } catch (err) { return; }
      if (!btn || btn.disabled) return;

      var mySeq = seq;
      var startUrl = location.href;

      cartHasPlan(function (isSub) {
        /* De winkelwagen is de enige betrouwbare bron. Een knop die zichtbaar is
           of een plan dat Firmhouse nog moet omzetten zegt niets - dit wel. */
        var url = isSub ? '/checkout?skip_shop_pay=true' : '/checkout';

        /* Geen abonnement: er is niemand anders die deze klik afhandelt, dus we
           gaan vrijwel meteen. Het kwartje wachttijd is er alleen zodat het thema
           voorrang krijgt als het toch zelf navigeert. */
        var wait = isSub ? WAIT_SUB : 250;

        setTimeout(function () {
          if (seq !== mySeq) return;
          if (location.href !== startUrl) return;
          if (window.__dwbForced) return;
          window.__dwbForced = true;
          log('door naar', url, isSub ? '(abonnement)' : '(eenmalig)');
          window.location.href = url;
        }, wait);
      });
    }, false);
  }

  /* ---------- Blijven toepassen ---------- */

  function start() { normalize(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  window.addEventListener('load', start);
  document.addEventListener('shopify:section:load', start);

  if (window.MutationObserver) {
    var scheduled = false;
    var obs = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      setTimeout(function () { scheduled = false; normalize(); }, 80);
    });
    try { obs.observe(document.documentElement, { childList: true, subtree: true }); } catch (e) {}
  }

  setInterval(normalize, 1000);

  window.dwbCheckoutStatus = function () {
    var knoppen = [];
    Array.prototype.forEach.call(document.querySelectorAll(BTN), function (b) {
      if (zichtbaar(b)) knoppen.push({
        tekst: (b.textContent || '').trim().replace(/\s+/g, ' '),
        slotjes: b.querySelectorAll('.dwb-lock-wrap').length,
        vreemdeIconen: Array.prototype.filter.call(b.querySelectorAll('svg'), function (s) {
          return !(s.classList && s.classList.contains('dwb-lock')) && s.getAttribute('data-dwb-verborgen') !== '1';
        }).length,
        onclick: b.getAttribute('onclick') ? 'aanwezig' : 'weg',
        betaalIconen: b.querySelectorAll('img').length
      });
    });
    var links = [];
    Array.prototype.forEach.call(document.querySelectorAll('[data-dwb-link="1"]'), function (l) {
      links.push({ tekst: l.textContent, zichtbaar: zichtbaar(l) });
    });
    return { abonnementInWagen: abonnementInWagen(), zichtbareKnoppen: knoppen, paypalLinks: links };
  };
})();
